export const NO_OPEN_ORDERS_TITLE = "Não há pedidos em aberto";
export const NO_CLEARED_ORDERS_TITLE = "Não há pedidos faturados";
export const NO_REJECTED_ORDERS_TITLE = "Não há pedidos reprovados";
